  const RealizeCustom = {
	FlashContent: window.FlashContent,
};

export default class FlashContent extends RealizeCustom.FlashContent {

   renderMessagesCustom () {      
      var isArray = Array.isArray(this.props.message);
      var messages = !isArray ? [this.props.message] : this.props.message;
      return messages.map(function(message, index) {

        if(message === "invalid_action_type") {
          return <p key={"flash_content_" + index} aria-label={Realize.i18n.t(`form.errors.${message}`)} tabIndex="0">{Realize.i18n.t(`form.errors.${message}`)}</p>;
        }

        return typeof message == "string" ? <p key={"flash_content_" + index} aria-label={message} tabIndex="0">{message}</p> : message;
      });
   }

   render () {
    return (
      <div className={this.className()}>
        {this.renderMessagesCustom()}
      </div>
    );
  }

}
